import {
  ListCancelClaimRequest,
  ListCancelClaimResponse
} from '@spilca/order_ts/v1/order/model_cancel_claim_pb';
import { Sorting } from '@spilca/order_ts/v1/order/common_pb';
import { createPagination, FILTER_PARAMS } from '@monorepo/helpers';
import { getGrpcPromise } from '@monorepo/grpc';
import cancelRequestFilterConstructor from '../cancelRequestFilterConstructor';

const cancelRequestConstructor = (
  filter: any,
  cancelService: any
): Promise<ListCancelClaimResponse.AsObject> => {
  const { queryKey, pageParam, pageSize } = filter;
  const [, params] = queryKey;
  const request = new ListCancelClaimRequest();

  const sort = new Sorting();
  sort.setFieldName('created_at');
  sort.setOrder(1);
  request.setSortingList([sort]);

  const cancelRequestFilter = cancelRequestFilterConstructor(params, null);
  const pager = createPagination(
    pageParam || filter[FILTER_PARAMS.page] || 1,
    pageSize
  );
  request.setPagination(pager);
  request.setFilter(cancelRequestFilter);
  return getGrpcPromise(cancelService)(request);
};

export default cancelRequestConstructor;
